import { render, staticRenderFns } from "./CardSpotlight.vue?vue&type=template&id=248a17f3&"
import script from "./CardSpotlight.vue?vue&type=script&lang=js&"
export * from "./CardSpotlight.vue?vue&type=script&lang=js&"
import style0 from "./CardSpotlight.vue?vue&type=style&index=0&id=248a17f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports